export default "__VITE_ASSET__8T2PR2Te__"